// FLOW-13 (SPEC S4, R8; PLAN G12) — a ferramenta HTTP é um flow, e se reconhece pela forma do YAML,
// sem chave nova no contrato: `params` (pode faltar), um passo `http` e um `return`. Com a forma, o
// editor abre a vista da ferramenta HTTP; sem ela, o canvas, como qualquer flow. Assim "Abrir no
// editor de flow" e um terceiro passo levam a ferramenta para o canvas sem perder nada.
//
// A regra, nesta ordem de leitura:
// - no topo, só `name`, `description`, `efeito`, `params` e `steps` (o `detached`, o `mode` e o resto
//   tiram a forma);
// - `steps` com exatamente dois itens: o primeiro `type: http` com `id`, o segundo `type: return`;
// - nenhum dos dois com `on_error` de rota (os passos da rota de erro): `fail` e `continue` não são
//   rota e ficam;
// - nenhum `respond`.
//
// O Rails lê a mesma regra nos passos compilados (`CofreDaConta::UsoDosSegredos.ferramenta_http?`, o
// `tipo: ferramenta_http` do "Usado por"), e um arquivo de contrato roda os mesmos casos nos dois
// lados (`spec/fixtures/flow13/formas.json`).
import { objetoLido } from './leituraYaml';

const ehObjeto = valor =>
  !!valor && typeof valor === 'object' && !Array.isArray(valor);

export const CHAVES_DA_FERRAMENTA_HTTP = [
  'name',
  'description',
  'efeito',
  'params',
  'steps',
];

const comRotaDeErro = passo => ehObjeto(passo?.on_error);

// A forma no flow já lido (o objeto do YAML).
export function formaDeFerramentaHttp(flow) {
  if (!ehObjeto(flow)) return false;
  if (
    Object.keys(flow).some(chave => !CHAVES_DA_FERRAMENTA_HTTP.includes(chave))
  ) {
    return false;
  }
  const { steps } = flow;
  if (!Array.isArray(steps) || steps.length !== 2) return false;
  const [chamada, retorno] = steps;
  if (!ehObjeto(chamada) || !ehObjeto(retorno)) return false;
  if (chamada.type !== 'http' || !chamada.id) return false;
  if (retorno.type !== 'return') return false;
  if (steps.some(passo => passo.type === 'respond')) return false;
  return !steps.some(comRotaDeErro);
}

// A forma no texto do editor. O YAML que não se lê (no meio da digitação) não tem a forma: o editor
// fica no canvas, que mostra o erro.
export function temFormaDeFerramentaHttp(texto) {
  if (typeof texto !== 'string' || !texto.trim()) return false;
  try {
    return formaDeFerramentaHttp(objetoLido(texto));
  } catch {
    return false;
  }
}
